var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_audio",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.338,
    height: 41.338,
    viewBox: "0 0 41.338 41.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.19,
    y1: 0.205,
    x2: 0.828,
    y2: 0.862,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ab6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b9ff1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14776",
    "data-name": "Path 14776",
    d: "M20.669,0A20.669,20.669,0,1,1,0,20.669,20.669,20.669,0,0,1,20.669,0Z",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_791_",
    transform: "translate(11.795 12.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_792_",
    d: "M16.093,27.64V26.484a7.242,7.242,0,0,0-14.484,0V27.64a4.022,4.022,0,0,0,2.414,7.24.8.8,0,0,0,.8-.8V27.638a.8.8,0,0,0-.8-.8,4.022,4.022,0,0,0-.8.081v-.43a5.633,5.633,0,1,1,11.265,0v.43a4.022,4.022,0,0,0-.8-.081.8.8,0,0,0-.8.8v6.437a.8.8,0,0,0,.8.8,4.022,4.022,0,0,0,2.414-7.24Z",
    transform: "translate(0 -19.242)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.fa17244aa9101e5f15570e86912ce673.svg";
export { ForwardRef as ReactComponent };